<div  style="min-width:300px; position:relative; " >
	 
 
           <nb-card>
           <nb-card-header>
                
 <div style="display:flex; width:100%">
                <span>Ключ</span>   
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="close()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>  
                </div>
           </nb-card-header>
           	<nb-card-body  style="" *ngIf="!loading; else load">
	 	
		<div style="padding:0px 5px;">
		<div class="h-text"><div>Ключ</div><div style="display:flex; margin-left:auto;">Використано</div></div>
		</div>
		<div class="items  scrollable-container">

		<div class="item" *ngFor="let key of keys">

		<div class="pass" >{{key.password}}</div><div  class="status">{{key.used ? 'Так' : ''}}</div>
		</div>
	
		</div>
 
        	</nb-card-body>
 		<nb-card-footer  style="display:flex;" *ngIf="!loading && keys?.length"> 
			<div style="display:flex; margin-left:auto;"> 
			<a (click)="loadKeys()"  href="javascript:;">Завантажити txt</a>
			</div>  
		 </nb-card-footer>
           </nb-card> 

 
      
	 

</div>


<ng-template #load>
	<nb-card-body>
    <div style="  z-index: 777; width:100%; min-height:350px; height:350px; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div>

	</nb-card-body>
</ng-template> 

